import 'css-chunksrc/client/scenes/workloads/wbs/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_1lx45_1"
};